import React, { Dispatch } from "react";
import { Action, State } from "./type";

export const QuestionContext = React.createContext({
    currentQuestionNo: 1,
    setQuestionId: (nextQuestionId: number) => {},
});

export const AppContext = React.createContext(
    {} as {
        state: State;
        dispatch: Dispatch<Action>;
    }
);
